<template>
  <v-row dense>
    <v-col cols="12">
      <template v-if="course_package">
        <h3 class="text-center">Pacote de curso: {{ course_package.name }}</h3>

        <v-row dense justify="center" class="py-3">
          <v-col cols="12" md="6" lg="4" v-for="course in course_package.courses" :key="course.id">
            <v-card>
              <v-card-text class="text-center">{{ course.name }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <span v-html="course_package.description"/>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" class="text-center">
            <h1>{{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(course_package.amount) }}</h1>
            <template v-if="course_package.type === 'FREE'">
              <h4>
                Curso Gratuito
              </h4>
            </template>
            <template v-else>
              <h4 v-if="course_package.type === 'SINGLE_PAYMENT'">
                Dividio em até {{ course_package.single_payment.installments }}x
              </h4>
              <h4>
                Pagamento via {{ course_package.formatted_payment_methods.join(' / ') }}
              </h4>
              <h4 v-if="course_package.type === 'PLAN' && course_package.plan.trial_days">
                Você ganha {{ course_package.plan.trial_days }} dias de avaliação
              </h4>
            </template>
          </v-col>
        </v-row>

        <v-row dense class="pt-4">
          <v-col cols="12">
            <template v-if="course_package.status === 'ACTIVE'">
              <v-btn large depressed dark block color="green" v-if="course_package.type === 'PLAN'" @click="toPlan()">
                Prosseguir com a assinatura
              </v-btn>
              <v-btn large depressed dark block color="green" v-else @click="setCartItem(course_package)">
                Adicionar ao Carrinho
              </v-btn>
            </template>
            <template v-else>
              <v-btn large depressed disabled block>
                O curso não está disponível no momento
              </v-btn>
            </template>
          </v-col>
        </v-row>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import { CoursePackage } from '@/services/resources'

import { mapActions } from 'vuex'

export default {
  mounted () {
    CoursePackage.show(this.$route.params.package).then((response) => {
      this.course_package = response.body
    })
  },
  data () {
    return {
      course_package: null
    }
  },
  methods: {
    toPlan () {
      this.$router.push({ name: 'plan', params: { package: this.$route.params.package } })
    },
    ...mapActions({
      setCartItem: 'Cart/setCartItem'
    })
  }
}
</script>

<style scoped>

</style>
